export enum HeaderKey {
  Authorization = 'authorization',
  Billing = 'billing',
  DataInsight = 'dataInsight',
  Dashboard = 'dashboard',
  Identity = 'identity',
  Master = 'master',
  Merchant = 'merchant',
  Marketing = 'marketing',
  Membership = 'membership',
  NestExporter = 'nestExporter',
  NestMaster = 'nestMaster',
  Pos = 'pos',
  Product = 'product',
  Purchase = 'purchase',
  Stock = 'stock',
  Store = 'store',
  Supplier = 'supplier',
  Settlement = 'settlement',
  Report = 'report',
  Tote = 'tote',
  Order = 'order',
  Workflow = 'workflow',
  Pim = 'pim'
}

export const API_ENDPOINT = {
  graphql: {
    url: '/graphql',
    headers: HeaderKey.Master
  },
  auth: {
    url: '/oauth/token',
    headers: HeaderKey.Authorization
  },
  products: {
    url: '/cjproducts',
    select: '/select',
    getCJArticleDetails: '/{articleNo}',
    headers: HeaderKey.Pim
  },
  uploadProducts: {
    url: '/pim/products',
    export: '/template/export',
    validate: '/template/validate',
    download: '/template/download',
    headers: HeaderKey.Pim
  },
  productMaster: {
    url: '/cjproducts',
    headers: HeaderKey.Pim
  },
  preOrderCatalog: {
    url: '/preorder-catalogs',
    get: '/{preorderNo}',
    cancel: '/cancel',
    getDropDown: '/dropdown',
    importStoreSubmit: '/import/store',
    downloadFileStoreTemplate: '/import/store/templates',
    submit: '/submit',
    exportStore: '/export/store',
    preOrderTransaction: '/preorder-transaction/export',
    downloadFileTemplate: '/import/templates',
    importValidate: '/import/validate',
    importSubmit: '/import/submit',
    export: '/export',
    createFlashSale: '/flash-sale/create',
    cancelFlashSale: '/flash-sale/cancel',
    downloadFileFlashSaleTemplate: '/flash-sale/import/templates',
    importFlashSaleValidate: '/flash-sale/import/validate',
    importFlashSaleSubmit: '/flash-sale/import/submit',
    checkPromotion: '/promotions/validate',
    headers: HeaderKey.Product
  },
  preOrderRequests: {
    url: '/preorder-requests',
    transactionExport: '/transaction/export',
    accountingExport: '/accounting/export',
    headers: HeaderKey.Stock
  },
  preOrderReport: {
    url: '/preorder-catalogs',
    exportPreOrderCatalog: '/export',
    reportConfidential: '/confidential/export',
    headers: HeaderKey.Report
  },
  preOrderTransactionsReport: {
    url: '/preorder-transactions',
    transaction: '/export',
    transactionsConfidential: '/confidential/export',
    compensate: '/compensate/export',
    headers: HeaderKey.Report
  },
  stores: {
    url: '/stores',
    storesPaging: '/search/store',
    validateLimitStore: '/validate-limit-create-store',
    headers: HeaderKey.Product,
    storeHeader: HeaderKey.Store
  },
  assortment: {
    url: '/tdproducts',
    get: '/assortment',
    productDetail: '/{articleNo}/details',
    catalogs: '/catalogs',
    z8Parameter: '/assortment/z8parameters',
    history: '/history/{productId}',
    headers: HeaderKey.Product
  },
  assortmentPim: {
    url: '/pim',
    catalogs: '/catalogs',
    export: '/catalogs/export',
    exportOrderList: '/catalogs/exportProductOrderList',
    headers: HeaderKey.Pim
  },
  barcodes: {
    url: '/barcodes',
    getList: '/list',
    verifyBarcode: '/exists/{barcodeNumber}',
    headers: HeaderKey.Pim
  },
  article: {
    url: '/articles',
    getList: '/list',
    headers: HeaderKey.Stock
  },
  productAssortment: {
    url: '/tdproducts/requests',
    headers: HeaderKey.Product,
    uploadUrl: '/tdproducts/images',
    bucketName: '/product-assortments-dev'
  },
  freshLiteCategory: {
    url: '/fresh-lite-categories',
    findByName: '/exists',
    checkFreshLite: '/{code}',
    headers: HeaderKey.Product
  },
  masterData: {
    url: '/product-select-values',
    headers: HeaderKey.Product
  },
  priceSetting: {
    url: '/price-settings',
    request: '/classes',
    get: '/classes/{classCode}',
    headers: HeaderKey.Product
  },
  pricing: {
    url: '/pricing',
    request: '/stackprices',
    get: '/stackprices/{articleNo}',
    delete: '/stackprices/delete',
    history: '/stackprices/history/{articleNo}',
    cjPrices: '/cjprices',
    tdPrices: '/tdprices',
    headers: HeaderKey.Product
  },
  shelf: {
    url: '/shelves',
    view: '/view/{shelfNo}',
    history: '/history/{shelfNo}',
    submitFirstLot: '/firstLot',
    activate: '/activate/{shelfNo}',
    generateItems: '/productList',
    headers: HeaderKey.Pim
  },
  shelfRequest: {
    url: '/shelves-requests',
    delete: '/{requestId}',
    history: '/history/{requestId}',
    save: '/save',
    submit: '/submit',
    view: '/{requestId}',
    importBarcodes: '/importBarcodes',
    importFirstLot: '/importFirstLot',
    exportFirstLot: '/exportFirstLot',
    validate: '/validate/{type}/{value}',
    approve: '/approveRequest',
    export: '/export',
    headers: HeaderKey.Pim
  },
  shelfFixAssetRequest: {
    url: '/shelf-fix-asset-requests',
    delete: '/{requestId}',
    history: '/history/{requestId}',
    save: '/save',
    submit: '/submit',
    view: '/{requestId}',
    importBarcodes: '/importBarcodes',
    importFirstLot: '/importFirstLot',
    exportFirstLot: '/exportFirstLot',
    validate: '/validate/{type}/{value}',
    approve: '/approveRequest',
    export: '/export',
    headers: HeaderKey.Pim
  },
  shelfInventoryRequest: {
    url: '/shelf-inventory-requests',
    delete: '/{requestId}',
    history: '/history/{requestId}',
    save: '/save',
    submit: '/submit',
    view: '/{requestId}',
    importBarcodes: '/importBarcodes',
    importFirstLot: '/importFirstLot',
    exportFirstLot: '/exportFirstLot',
    downloadImportBarCodeTemplate: '/export/template',
    validate: '/validate/{type}/{value}',
    approve: '/approveRequest',
    export: '/export',
    headers: HeaderKey.Pim
  },
  shelfInventory: {
    url: '/shelf-inventories',
    view: '/view/{shelfNo}',
    history: '/history/{shelfNo}',
    submitFirstLot: '/firstLot',
    activate: '/activate/{shelfNo}',
    getShelfList: '/firstLot',
    generateItems: '/details',
    export: '/export',
    headers: HeaderKey.Pim
  },
  shelfFixAsset: {
    url: '/shelf-fix-assets',
    view: '/view/{shelfNo}',
    history: '/history/{shelfNo}',
    submitFirstLot: '/firstLot',
    activate: '/activate/{shelfNo}',
    generateItems: '/productList',
    generateFixAssetItems: '/details',
    headers: HeaderKey.Pim
  },
  merchantSelectValue: {
    url: '/merchant-select-values',
    headers: HeaderKey.Merchant
  },
  shelfReplenishmentPhoto: {
    url: '/refill-recommendation-review',
    list: '/list',
    view: '/{jobNo}',
    history: '/{jobNo}/history',
    submit: '/{jobNo}/verify',
    summary: '/summary',
    headers: HeaderKey.Store
  },
  focusSalesProduct: {
    url: '/store-operation/focus-sales-product',
    template: '/template',
    import: '/import',
    download: '/{requestNo}/download',
    cancel: '/{requestNo}/cancel',
    history: '/{requestNo}/history',
    headers: HeaderKey.Store
  },
  merchantsRequest: {
    url: '/merchants-requests',
    validate: '/validate/{type}/{value}',
    save: '/save',
    submit: '/submit',
    fileUrl: '/fileUrl',
    view: '/{merchantRequestId}',
    approveRequest: '/approveRequest',
    delete: '/{merchantRequestId}',
    history: '/history/{merchantRequestId}',
    getMerchantVersion: '/getVersion/{merchantRequestId}',
    getShelfDetails: '/getShelfDetails/{storeCode}',
    getMerchantPending: '/check-pending/{merchantId}',
    headers: HeaderKey.Merchant
  },
  merchant: {
    url: '/merchants',
    viewMerchant: '/view/{merchant}',
    allStore: '/all/stores',
    listStore: '/{merchant}/stores',
    generateUser: '/{merchant}/generateOwner',
    addResetOwnerLog: '/{merchant}/addResetOwnerLog',
    history: '/history/{merchant}',
    getStore: '/{merchant}/stores',
    headers: HeaderKey.Merchant
  },
  storeGroup: {
    url: '/merchants',
    submit: '/{merchantId}/groups',
    get: '/{merchantId}/groups/{groupId}',
    groupList: '/groups/list',
    headers: HeaderKey.Merchant
  },
  storeGroups: {
    url: '/store-groups',
    downloadFileTemplate: '/templates',
    importValidate: '/validate',
    importSubmit: '/import',
    importLatest: '/import-latest',
    headers: HeaderKey.Merchant
  },
  storeConsultant: {
    url: '/store-consultants',
    get: '/{userId}',
    submit: '/submit',
    downloadFileTemplate: '/import/templates',
    validateFile: '/import/validate',
    importSubmit: '/import/submit',
    headers: HeaderKey.Store
  },
  regionalStructure: {
    url: '/regional-structures',
    downloadFileTemplate: '/template',
    importSubmit: '/import',
    download: '/{docNo}/download',
    cancel: '/{docNo}/cancel',
    history: '/{docNo}/history',
    headers: HeaderKey.Identity
  },
  store: {
    url: '/stores',
    lockSale: '/lock-sale',
    view: '/view/{storeNo}',
    generatePOSRegisCode: '/{storeNo}/generatePos',
    updatePOSRegisCode: '/{storeNo}/updatePos',
    deletePOS: '/{storeNo}/deletePos',
    deactivatePOS: '/{storeNo}/deactivatePos',
    orderSchedule: '/orderSchedule',
    history: '/history/{storeNo}',
    export: '/export',
    exportStoreConfidential: '/confidential/export',
    exportMoneyIn: '/export/moneyIn',
    printStoreAssortmentPdf: '/print/store-pos-price-tag/{storeNo}/{format}/{locale}',
    activate: '/{storeNo}/status/activate',
    deactivate: '/{storeNo}/status/deactivate',
    exportAdjustment: '/{exportBy}/adjusts/export',
    inventoryCount: '/{exportBy}/export',
    exportNoWSP: '/{exportBy}/no-wsp/export',
    exportInventoryVariance: '/count/exportInventoryVariance/pdf/th',
    redeemTransaction: '/redeem-transaction/export',
    rewardTransaction: '/reward-transaction/export',
    imageSignedUrl: '/imageSignedUrl',
    exportInventoryVarianceNestPDF: '/count/inventoryVariance/nest/pdf/th',
    exportOrderScheduleTemplate: '/storeOrderSchedule/import/templates',
    importStoreOrderSchedule: '/import/storeOrderSchedule',
    importValidate: '/import/validate',
    terminateDateStore: '/{storeNo}/terminate',
    validateDeviceActivation: '/{storeNo}/devices/{deviceNo}/validate-device-activation',
    exportSelectStoreTemplate: '/template/export',
    importSelectStoreValidate: '/template/validate',
    importTemplateStoreValidate: '/import/template/validate',
    templateSelectStoreDownload: '/template/download',
    defaultConfigStorageType: '/default/config/split-storage-types',
    validateLimitStore: '/validate-limit-create-store',
    headers: HeaderKey.Store
  },
  storeReport: {
    url: '/stores',
    exportBillPayment: '/export/billPayment',
    headers: HeaderKey.Report
  },
  storeRequest: {
    url: '/stores-requests',
    validate: '/validate/{type}/{value}',
    save: '/save',
    submit: '/submit',
    delete: '/{storeId}',
    view: '/{storeId}',
    history: '/history/{storeId}',
    getStoreVersion: '/getVersion/{storeId}',
    approve: '/approveRequest',
    headers: HeaderKey.Merchant
  },
  destroy: {
    url: '/destroys',
    allDestroyDocument: '/all/doc',
    exportDestroyDocument: '/{docNo}/print/pdf/th',
    headers: HeaderKey.Store
  },
  users: {
    url: '/users',
    get: '/{no}',
    uploadUserFileAppend: '/{userName}/files',
    deleteUserFileAppend: '/{userName}/files/{fileName}',
    resetPassword: '/{userName}/resetPassword',
    activateUser: '/{userName}/activate/{status}',
    createOTP: '/{userName}/otp',
    verifyOTP: '/{userName}/verifyOtp',
    forgotPassword: '/{userName}/forgetPassword',
    forgotUsername: '/{mobileNumber}/forgetUserName',
    forceChangePassword: '/{userName}/forceChangePassword',
    list: '/list',
    searchUserByRole: '/search/list',
    authorityScopes: '/authority-scopes',
    userAuthorityScopes: '/{no}/authority-scopes',
    headers: HeaderKey.Identity
  },
  dashboard: {
    url: '',
    tasksByRole: '/tasks',
    countTask: '/tasks/count',
    headers: HeaderKey.Identity
  },
  report: {
    url: '/report',
    myReport: '/my-report',
    downloadReport: '/artifact/{reportNo}',
    downloadPriceTag: '/price-tag/{reportNo}',
    headers: HeaderKey.Report
  },
  order: {
    url: '/orders',
    view: '/view/{orderNo}',
    print: '/{id}/print/{format}/{locale}',
    export: '/export',
    release: '/release',
    history: '/view/history/{orderNo}',
    headers: HeaderKey.Order
  },
  orderRequest: {
    url: '/orders-requests',
    save: '/save',
    submit: '/submit',
    delete: '/{orderId}',
    view: '/{orderId}',
    viewReferenceNo: '/view/{orderRequestNo}',
    history: '/history/{orderId}',
    approve: '/approveRequest',
    getStoreFirstLot: '/firstlot/stores',
    getStoreSpecial: '/replenish/stores',
    validateOrderList: '/validate/orderList',
    downloadFileTemplate: '/imports/templates',
    importValidate: '/imports/validates',
    importSubmit: '/imports/submits',
    getEstimatedDelivery: '/estimated/delivery-date',
    defaultDeliveryDates: '/firstlot/default-delivery-dates',
    headers: HeaderKey.Order
  },
  orderRequestFixAsset: {
    url: '/orders-requests/fix-asset',
    save: '/save',
    submit: '/submit',
    storeUseSubmit: '/storeuse/submit',
    delete: '/{orderId}',
    view: '/{orderId}',
    history: '/history/{orderId}',
    approve: '/approveRequest',
    getStore: '/firstlot/stores',
    validateOrderList: '/validate/orderList',
    downloadFileTemplate: '/imports/templates',
    importValidate: '/imports/validates',
    importSubmit: '/imports/submits',
    headers: HeaderKey.Order
  },
  orderRequestInventory: {
    url: '/orders-requests/inventory',
    save: '/save',
    submit: '/submit',
    assignQuantitySubmit: '/assign-quantity/submit',
    assignQuantitySave: '/assign-quantity/save',
    delete: '/{orderId}',
    view: '/{orderId}',
    approve: '/approveRequest',
    getStore: '/firstlot/stores',
    downloadFileTemplate: '/imports/templates',
    importUpdateQtyValidate: '/imports/{orderRequestId}',
    importAddSelectiveItem: '/importSelectiveItems/validate',
    importSubmit: '/imports/submits',
    export: '/export/{orderRequestId}',
    headers: HeaderKey.Order
  },
  exportOrderRequestFixAsset: {
    url: '/orders-requests-fix-asset',
    export: '/export/{selected}',
    headers: HeaderKey.Order
  },
  orderRequestStoreUse: {
    url: '/pim/catalogs',
    export: '/exportProductOrderList',
    headers: HeaderKey.Pim
  },
  orderRequestSelective: {
    url: '/pim/catalogs',
    export: '/export',
    headers: HeaderKey.Pim
  },
  receiveOrder: {
    url: '/receive-orders',
    getByNo: '/{receiveOrderNo}',
    toteExport: '/tote/export',
    exceedExport: '/exceed/export',
    print: '/{receiveOrderNo}/print',
    images: '/{receiveOrderNo}/images/{index}',
    headers: HeaderKey.Order
  },
  storeLocationReport: {
    url: '/store-location',
    exportDc: '/dc/export',
    headers: HeaderKey.Report
  },
  deliveryOrder: {
    url: '/delivery-orders',
    get: '/{id}',
    edit: '/edit',
    update: '/{id}/split/draft',
    submit: '/{id}/split/submit',
    exportPicking: '/export-picking',
    importPicking: '/import-picked',
    print: '/{id}/print/{format}/{locale}',
    cancel: '/cancel',
    cancelDispatch: '/dispatch/cancel',
    reschedule: '/rescheduleDate',
    history: '/history/{doNo}',
    delivered: '/delivered',
    headers: HeaderKey.Order
  },
  shelfType: {
    url: '/shelf-types',
    uploadOrder: '/uploadOrder',
    generateOrder: '/generateOrder',
    getShelfTypes: '/getShelfTypes',
    fileUrl: '/fileUrl',
    headers: HeaderKey.Pim
  },
  shipment: {
    url: '/shipments',
    update: '/{shipmentNo}',
    getByShipmentNumber: '/{shipmentNo}',
    deleteByShipmentNumber: '/{shipmentNo}',
    confirmLoad: '/confirm-load',
    dispatch: '/{shipmentNo}/dispatch',
    exportShipment: '/export',
    downloadFileTemplate: '/import/templates',
    submitImport: '/import/submits',
    importValidate: '/import/validates',
    print: '/{shipmentNo}/print/customer-delivery-note',
    headers: HeaderKey.Order
  },
  claim: {
    url: '/crs',
    list: '/all',
    get: '/get/{claimRequestNo}',
    approve: '/approve',
    reject: '/{claimRequestNo}/reject',
    fileUrl: '/imageSignedUrl',
    draft: '/draft/{receiveOrderNo}',
    imagesReferenceDocument: '/{claimRequestNo}/images/{index}',
    regenerateApprovalWorkflow: '/approval-flow/regenerate',
    headers: HeaderKey.Order
  },
  promotions: {
    url: '/promotions',
    export: '/export',
    exportStore: '/export/{promotionCode}',
    get: '/{id}',
    themes: '/themes',
    themesList: '/themes/list',
    cancel: '/cancel',
    headers: HeaderKey.Marketing
  },
  promotionsRequest: {
    url: '/promotion-requests',
    import: '/store/import',
    exportTemplate: '/export/template',
    exportRequest: '/export/{id}',
    get: '/{id}',
    reject: '/reject',
    approve: '/approve',
    requestCancel: '/cancel',
    requestsSubmit: '/submit',
    requestsID: '/{requestId}',
    headers: HeaderKey.Marketing
  },
  promotionsV2: {
    url: '/promotions',
    get: '/V2/{id}/view',
    list: '/V2/list',
    exportItems: '/V2/{id}/export',
    exportStore: '/V2/{id}/export/store',
    themesList: '/themes/list',
    uploadImage: '/V2/{id}/upload',
    getSpecialFile: '/V2/{docNo}/download/special-file',
    themes: '/themes',
    cancel: '/V2/cancel',
    history: '/V2/history/{id}',
    changeExpirationDate: '/V2/{id}/change-expiration',
    headers: HeaderKey.Marketing
  },
  promotionsRequestV2: {
    url: '/promotion-requests',
    requestCancel: '/V2/cancel',
    requestDelete: '/V2/{id}',
    requestsSubmit: '/V2/submit',
    exportTemplate: '/export/template',
    exportRequest: '/V2/{id}/export/store',
    import: '/V2/import/store',
    reject: '/V2/reject',
    approve: '/V2/approve',
    history: '/V2/history/{requestId}',
    requestByID: '/{requestId}',
    generateWorkflow: '/V2/generate/workflow',
    viewRequest: '/V2/{id}/view',
    exportView: '/V2/{id}/export',
    copy: '/V2/{id}/copy',
    downloadFileTemplate: '/V2/download/promotion/item/template/{type}/{promotionConditionKey}',
    importPromotionItem: '/V2/import/promotion/item/{type}/{promotionConditionKey}',
    regenerateApprovalWorkflow: '/V2/approval-flow/regenerate',
    headers: HeaderKey.Marketing
  },
  promotionsReport: {
    url: '/promotions',
    export: '/export',
    headers: HeaderKey.Report
  },
  promotionsV2Report: {
    url: '/promotions',
    export: '/V2/export',
    headers: HeaderKey.Report
  },
  purchaseConditionRequest: {
    url: '/purchase-condition-request',
    exportTemplate: '/discount/export',
    discount: '/discount',
    import: '/discount/import',
    deleteImportFile: '/discount/import/{previousImportId}',
    exportOrderDeliveryScheduleWeeklyTemplate: '/weekly-schedule/export',
    importOrderDeliveryScheduleWeeklyTemplate: '/weekly-schedule/import',
    exportOrderDeliveryScheduleMonthlyTemplate: '/monthly-schedule/export',
    importOrderDeliveryScheduleMonthlyTemplate: '/monthly-schedule/import',
    DeliveryScheduleWeekly: '/weekly-schedule',
    orderDeliveryScheduleWeekly: '/weekly-schedule',
    orderDeliveryScheduleMonthly: '/monthly-schedule',
    purchaseConditionList: '/purchase-condition',
    exists: '/isPendingForUpdate/{supplierId}',
    get: '/view/{id}',
    submit: '/submit',
    approve: '/approve',
    reject: '/reject',
    cancel: '/cancel',
    headers: HeaderKey.Purchase
  },
  purchaseCondition: {
    url: '/purchase-condition',
    getViewById: '/view/{supplierCode}',
    discount: '/discount',
    weeklySchedule: '/weekly-schedule',
    monthlySchedule: '/monthly-schedule',
    supplierDc: '/supplier-dc',
    supplierContract: '/supplier-contact',
    deleteContract: '/supplier-contact/{id}',
    deleteDc: '/supplier-dc/{id}',
    exportWeekly: '/weekly-schedule/export',
    exportCalendar: '/monthly-schedule/export',
    exportDiscount: '/discount/export',
    headers: HeaderKey.Purchase
  },
  purchaseRequest: {
    url: '/purchase-requests',
    get: '/{id}',
    deliveryDetail: '/deliveryDetail/default',
    contacts: '/contacts',
    deleted: '/{id}',
    cancel: '/cancel',
    submit: '/submit',
    approve: '/approve',
    reject: '/reject',
    supplierPromotions: '/supplier/promotions',
    purchaseProductPrice: '/purchase-product-prices',
    purchaseProductFreePrice: '/purchasing-price/supplier-warehouse-free-article',
    exportPr: '/export',
    import: '/import',
    previewDiscount: '/preview-discount',
    headers: HeaderKey.Purchase
  },
  purchaseProductPricesTemplate: {
    url: '/purchase-product-prices-template',
    export: '/export',
    headers: HeaderKey.Purchase
  },
  purchaseOrder: {
    url: '/purchase-orders',
    get: '/{id}',
    cancel: '/cancel',
    close: '/close',
    print: '/{id}/print/{format}/{locale}',
    exportPo: '/export',
    rescheduleDeliveryDate: '/reschedule-delivery-date',
    headers: HeaderKey.Purchase
  },
  goodsReceive: {
    url: '/goods-receives',
    getByPoNo: '/{poNo}',
    getById: '/view/{id}',
    submit: '/submit',
    cancel: '/cancel',
    headers: HeaderKey.Purchase
  },
  supplierGroupRequest: {
    url: '/supplier-group-requests',
    get: '/{id}',
    getStoreSupplier: '/{id}/store-suppliers',
    submit: '/submit',
    exportTemplate: '/export-template',
    export: '/export',
    import: '/import',
    approve: '/approve',
    reject: '/reject',
    cancel: '/cancel',
    delete: '/{id}',
    checkExisting: '/{supplierGroupNo}/exists',
    headers: HeaderKey.Supplier
  },
  vouchers: {
    url: '/vouchers',
    cancel: '/cancel',
    get: '/{voucherCode}',
    export: '/export',
    report: '/report',
    history: '/history/{id}',
    headers: HeaderKey.Marketing
  },
  advertisements: {
    url: '/advertisements',
    defaultAds: '/default',
    get: '/{adsNo}',
    submit: '/submit',
    cancel: '/cancel',
    uploadUrl: '/images',
    imageDirectory: '/images/{directory}',
    bucketName: '/pos-ads-dev',
    headers: HeaderKey.Marketing
  },
  vouchersRequest: {
    url: '/voucher-requests',
    requestsID: '/{requestId}',
    submit: '/submit',
    approve: '/approve',
    reject: '/reject',
    cancel: '/cancel',
    importValidate: '/import/validate',
    importTemplates: '/import/templates',
    importSubmit: '/import/submit',
    generateWorkflow: '/generate-workflow',
    regenerateApprovalWorkflow: '/approval-flow/regenerate',
    headers: HeaderKey.Marketing
  },
  vouchersRequestV2: {
    url: '/voucher-requests-v2',
    list: '/list',
    view: '/view/{requestNo}',
    createDraft: '/create-draft',
    generateStores: '/{requestNo}/generate-stores',
    confirmStores: '/{requestNo}/confirm-stores',
    downloadStores: '/{requestNo}/download-stores',
    downloadStoreTemplate: '/download-store-template',
    importStores: '/{requestNo}/import-stores',
    generateApprovalWorkflow: '/{requestNo}/generate-approval-flow',
    actions: '/{requestNo}/actions',
    submit: '/{requestNo}/submit',
    headers: HeaderKey.Marketing
  },
  supplier: {
    url: '/suppliers',
    importValidate: '/import/validate',
    downloadFileTemplate: '/import/templates',
    importSubmit: '/import/submit',
    export: '/export',
    list: '/list',
    get: '/{supplierCode}',
    activate: '/activate',
    validate: '/validate',
    ediSetting: '/ediSetting',
    headers: HeaderKey.Supplier
  },
  rewardRequest: {
    url: '/reward-requests',
    requestsID: '/{requestId}',
    submit: '/submit',
    approve: '/approve',
    reject: '/reject',
    cancel: '/cancel',
    import: '/import',
    export: '/export',
    validate: '/validate',
    headers: HeaderKey.Marketing
  },
  reward: {
    url: '/rewards',
    get: '/{rewardNo}',
    cancel: '/cancel',
    active: '/active/list',
    summary: '/active/summary',
    headers: HeaderKey.Marketing
  },
  rewardCatalogRequest: {
    url: '/reward-catalog-requests',
    validate: '/validate/{type}/{value}',
    save: '/save',
    submit: '/submit',
    fileUrl: '/fileUrl',
    approve: '/approve',
    reject: '/reject',
    cancel: '/cancel',
    view: '/{rewardCatalogRequestId}',
    delete: '/{id}',
    exportStore: '/export/{id}',
    importStoreSubmit: '/store/import',
    downloadFileStoreTemplate: '/export/template',
    history: '/history/{requestId}',
    headers: HeaderKey.Marketing
  },
  rewardCatalog: {
    url: '/reward-catalog',
    view: '/{requestNo}',
    history: '/history/{catalogId}',
    export: '/export',
    exportStore: '/export/{rewardCatalogNo}',
    cancel: '/cancel',
    changeExpiration: '/change-expire-date/{catalogId}',
    headers: HeaderKey.Marketing
  },
  rewardPointCash: {
    url: '/point-cash',
    setting: '/setting',
    headers: HeaderKey.Marketing
  },
  tdProduct: {
    url: '/barcodes',
    getDropDown: '/pickingBarcodes',
    headers: HeaderKey.Pim
  },
  role: {
    url: '/roles',
    get: '/{roleNo}',
    list: '/list',
    deleteRole: '/{id}',
    history: '/{roleNo}/histories',
    headers: HeaderKey.Identity
  },
  permission: {
    url: '/permissions',
    list: '/list',
    view: '/{code}',
    roles: '/{code}/roles',
    remove: '/{roleNo}/permissions/{code}',
    headers: HeaderKey.Identity
  },
  stocks: {
    url: '/stocks',
    warehouseArticleNo: '/{articleNo}',
    warehouseMovement: '/{warehouse}/{articleNo}/movements',
    stockByLocationType: '/{locationType}/{articleNo}',
    adjusts: '/adjusts',
    adjustsValidate: '/adjusts/validate',
    getAdjustStoreByDocNo: '/adjusts/{docNo}',
    getAdjustStoreItemsByDocNo: '/adjusts/{docNo}/items',
    forceCompleteAdjust: '/adjusts/complete',
    history: '/adjusts/history/{docNo}',
    getWarehouseArticleNo: '/warehouse/{articleNo}',
    export: '/{exportBy}/export',
    importAdjustsValidate: '/adjusts-request/import/validate',
    importAdjusts: '/adjusts-request/import/submit',
    adjustsRequest: '/adjusts-request/list',
    adjustsRequestView: '/adjusts-request/view/{requestNo}',
    generateWorkflow: '/adjusts-request/generate/workflow',
    regenerateWorkflow: '/adjusts-request/approval-flow/regenerate',
    validateCreateAdjust: '/adjusts-request/validate',
    submitAdjustRequest: '/adjusts-request/submit',
    approveAdjustRequest: '/adjusts-request/approve',
    rejectAdjustRequest: '/adjusts-request/reject',
    cancelAdjustRequest: '/adjusts-request/cancel',
    historyAdjustRequest: '/adjusts-request/history/{requestNo}',
    headers: HeaderKey.Stock
  },
  stocksLocation: {
    url: '/locations',
    headers: HeaderKey.Stock
  },
  stocksLocationByPermission: {
    url: '/locations-by-permission',
    headers: HeaderKey.Stock
  },
  memberRewards: {
    url: '/member-rewards',
    memberRewardTransactionReport: '/transaction/export',
    memberRewardAccountingReport: '/accounting/export',
    headers: HeaderKey.Stock
  },
  memberRewardTransactions: {
    url: '/member-reward-transactions',
    memberRewardTransactionReport: '/export',
    memberRewardTransactionReportWithPrice: '/with-price/export',
    headers: HeaderKey.Report
  },
  stockTransferRequest: {
    url: '/stocks',
    validate: '/transfer-request/validate',
    list: '/transfer/list',
    create: '/transfer/create',
    exportTemplate: '/transfer-request/export',
    get: '/transfer/view/{id}',
    getByDocNo: '/transfer/view/doc-no/{docNo}',
    delete: '/transfer/delete/{id}',
    cancel: '/transfer-request/cancel',
    update: '/transfer/update',
    approval: '/transfer-request/approval',
    import: '/transfer-request/import',
    submit: '/transfer-request/submit',
    history: '/transfer-request/{id}/history',
    headers: HeaderKey.Stock
  },
  stockTransfer: {
    url: '/stocks',
    list: '/transfer-order/list',
    get: '/transfer-order/{docNo}',
    close: '/transfer-order/close',
    history: '/transfer-order/{id}/history',
    headers: HeaderKey.Stock
  },
  stockTransferGr: {
    url: '/stocks',
    list: '/transfer-goods-receive/list',
    history: '/transfer-goods-receive/history/{id}',
    get: '/transfer-goods-receive/{id}',
    headers: HeaderKey.Stock
  },
  groupOrder: {
    url: '/orders',
    view: '/view/{orderNo}',
    history: '/history/{id}',
    get: '/transfer-order/{docNo}',
    close: '/transfer-order/close',
    export: '/transfer-order/export',
    headers: HeaderKey.Order
  },
  stockProduct: {
    url: '/tdproducts',
    headers: HeaderKey.Stock
  },
  salesTransactionReport: {
    url: '/sales-transactions',
    export: '/export',
    exportConfidential: '/confidential/export',
    headers: HeaderKey.Report
  },
  salesTransactionConfidentialReport: {
    url: '/sales-transactions-confidential',
    export: '/export',
    headers: HeaderKey.Report
  },
  supplierCouponReconcileReport: {
    url: '/supplier-coupon-reconcile',
    export: '/export',
    headers: HeaderKey.Store
  },
  storeAssortment: {
    url: '/store-assortments',
    view: '/view/{storeNo}',
    history: '/history/{storeNo}',
    list: '/list',
    getAssortment: '/{storeNo}',
    getZ8Factor: '/z8Factor/{id}',
    downloadTemplate: '/store-assortments-template/export',
    importStoreAssortment: '/import',
    exportByProduct: '/exportByProduct',
    submitDownload: '/{storeCode}/submitDownload',
    download: '/{uuid}/download',
    checkIsReadyDownload: '',
    priceTag: '/price-tag/first-lot',
    downloadHeaders: {
      'x-host': 'store.file.api.tdtech.app',
      'x-tenant-id': '*:*:*:*'
    },
    headers: HeaderKey.Store
  },
  storeAssortmentRequest: {
    url: '/store-assortment-requests',
    view: '/{requestNo}',
    validateStoreAssortment: '/validate',
    submit: '/submit',
    downloadSpecialAssortmentTemplate: '/special-assortment/template',
    downloadShelfOptionTemplate: '/shelf-option/template',
    uploadSpecialAssortment: '/import',
    exportStoreAssortmentRequest: '/store-assortment-requests/export/{requestNo}',
    history: '/history/{requestNo}',
    approve: '/approve',
    cancel: '/cancel',
    headers: HeaderKey.Store
  },
  monthlyPartnerProfitSharing: {
    url: '/monthly-partner-profit-sharing',
    report: '/reportSignedUrl/{id}',
    uploadMonthlyPartnerProfitSharingFileAppend: '/validate-import/{runDate}',
    submit: '/submit/{runDate}',
    headers: HeaderKey.Billing
  },
  profitSharing: {
    url: '/partner-profit-sharing',
    export: '/export',
    print: '/print/{runDate}/{docNo}',
    view: '/view/{id}',
    headers: HeaderKey.Billing
  },
  promotionCompensateReport: {
    url: '/promotion-compensate',
    export: '/export',
    headers: HeaderKey.Report
  },
  ssrResult: {
    url: '/ssr-orders',
    search: '/result',
    export: '/fileUrl',
    history: '/history/{id}',
    headers: HeaderKey.Order
  },
  supplierPrice: {
    url: '/supplier-price-configs',
    get: '/article-price-configs',
    import: '/{deliveryMethod}/import',
    export: '/export',
    template: '/template',
    importSupplierPriceMultipleArticleTemplate: '/multiple-article/template',
    importSupplierPriceMultipleArticle: '/multiple-article',
    multiArticleImportStatus: '/can/bulk-import',
    headers: HeaderKey.Product
  },
  taskAssignmentRequest: {
    url: '/task-assignment-requests',
    get: '/{id}',
    submit: '/submit',
    downloadFileStoreTemplate: '/import/templates',
    validateFileStore: '/import/validate',
    importStoreSubmit: '/import',
    approve: '/approve',
    reject: '/reject',
    cancel: '/cancel',
    exportStore: '/export',
    headers: HeaderKey.Store
  },
  taskAssignment: {
    url: '/task-assignment',
    get: '/{taskNo}',
    loadTaskList: '/task',
    exportStore: '/store/export',
    uploadUrl: '/upload',
    cancel: '/cancel',
    imageDirectory: '/task-assignment/{directory}',
    imageSignedUrl: '/imageSignedUrl',
    headers: HeaderKey.Store
  },
  taskRequest: {
    url: '/task-assignment-requests',
    get: '/{id}',
    submit: '/submit',
    headers: HeaderKey.Store
  },
  urgentAnnouncement: {
    url: '/urgent-announcements',
    headers: HeaderKey.Store
  },
  taskAssignmentResponse: {
    url: '/task-assignment-response',
    get: '/{responseNo}',
    put: '/{status}',
    getStoreConsultant: '/{responseNo}/store-consultant',
    exportResponse: '/export/response',
    exportSurvey: '/export/survey',
    imageDirectory: '/task-assignment/{directory}',
    imageSignedUrl: '/imageSignedUrl',
    headers: HeaderKey.Store
  },
  masters: {
    url: '/masters',
    store: '/store',
    headers: HeaderKey.Stock
  },
  warehousesStores: {
    url: '/warehouses-stores',
    headers: HeaderKey.Pim
  },
  membership: {
    url: '/membership',
    member: '/members',
    view: '/members/{id}',
    getMemberStore: '/member-stores',
    printPointStatement: '/{memberNo}/point/print/{month}',
    memberPaging: '/members/memberId',
    headers: HeaderKey.Membership
  },
  memberPoint: {
    url: '/membership',
    getPointSettingByCriteria: '/point-setting',
    getPointSettingView: '/point-setting/view/{type}',
    checkMemberPointIsAwaitingApprove: '/point-setting-requests/{type}',
    specialPointList: '/special-point',
    specialPointCancel: '/special-point/cancel',
    submit: '/point-setting-requests/submit',
    headers: HeaderKey.Membership
  },
  memberPointRequest: {
    url: '/membership',
    getPointSettingRequestByCriteria: '/point-setting-requests',
    view: '/point-setting-requests/view/{requestNo}',
    approve: '/point-setting-requests/approve',
    reject: '/point-setting-requests/reject',
    cancel: '/point-setting-requests/cancel',
    save: '/special-point-requests',
    submit: '/special-point-requests/submit',
    specialPointReject: '/special-point-requests/reject',
    specialPointApprove: '/special-point-requests/approve',
    getSpecialPointById: '/special-point-requests/{id}',
    downloadFileTemplate: '/special-point-requests/import/template',
    importValidate: '/special-point-requests/import/validate',
    importSubmit: '/special-point-requests/import/submit',
    headers: HeaderKey.Membership
  },
  memberExcludeItem: {
    url: '/membership',
    getMemberExcludeItemByCriteria: '/point-exclude-item',
    getMemberExcludeItemView: '/point-exclude-item/{id}',
    downloadFileTemplate: '/point-exclude-item/export/template',
    submitImport: '/point-exclude-item/import',
    submit: '/point-exclude-item/submit',
    exportExcludeItems: '/point-exclude-item/export',
    cancel: '/point-exclude-item/cancel',
    headers: HeaderKey.Membership
  },
  notForSale: {
    url: '/product',
    downloadFileTemplate: '/not-for-sale/export/template',
    getNotForSaleItemView: '/not-for-sale/{id}',
    import: '/not-for-sale/import',
    export: '/not-for-sale/export/{id}',
    submit: '/not-for-sale/submit',
    cancel: '/not-for-sale/cancel',
    getNotForSaleByCriteria: '/not-for-sale',
    headers: HeaderKey.Pim
  },
  specialRetailPrice: {
    url: '/pim/special-retail-prices',
    getByCriteria: '/list',
    downloadImportFile: '/{szNo}/download-items',
    history: '/{szNo}/history',
    cancel: '/{szNo}/cancel',
    headers: HeaderKey.Pim
  },
  specialRetailPriceRequest: {
    url: '/pim/special-retail-price-requests',
    getByCriteria: '/list',
    getRequestDetail: '/{requestId}',
    hasAwaitingApprovalRequest: '/validate-creatable',
    downloadFileTemplate: '/download-template',
    import: '/import',
    downloadImportFile: '/download-items',
    validateWorkflow: '/generate-workflow',
    submit: '',
    approve: '/{requestId}/approve',
    reject: '/{requestId}/reject',
    cancel: '/{requestId}/cancel',
    history: '/{requestId}/history',
    regenerateApprovalWorkflow: '/{requestId}/approval-flow/regenerate',
    headers: HeaderKey.Pim
  },
  z8HoldRequest: {
    url: '/z8hold-requests',
    export: '/export',
    headers: HeaderKey.Order
  },
  pointEarnAndBurnReport: {
    url: '/membership',
    stores: '/stores',
    exportEarnTransaction: '/report/earn-point',
    headers: HeaderKey.Membership
  },
  exporter: {
    url: '/exporter',
    notify: '/notify',
    metrics: '/metrics',
    headers: HeaderKey.NestExporter
  },
  customer360: {
    url: '/insight/customer360',
    template: '/template',
    viewTemplate: '/template/{id}',
    preview: '/template/preview',
    folderList: '/template/folderList',
    saveTemplate: '/template/save',
    manageAccess: '/template/permission',
    deleteTemplate: '/template/{templateId}',
    headers: HeaderKey.DataInsight
  },
  customer360Export: {
    url: '/customer360',
    export: '/export',
    headers: HeaderKey.Report
  },
  dataInsight: {
    url: '/insight',
    address: '/address',
    audience: '/audience',
    dashboard: '/dashboard/{group}',
    headers: HeaderKey.DataInsight
  },
  workflow: {
    url: '/workflows',
    approvalWorkflowNo: '/{no}',
    template: '/import/template',
    validate: '/import/validate',
    submit: '/submit',
    exportDetails: '/approval-detail/export',
    headers: HeaderKey.Workflow
  },
  latePaymentNotice: {
    url: '/late-payment-notices',
    view: '/view',
    submit: '/submit',
    validate: '/import/validate',
    downloadTemplate: '/import/template',
    headers: HeaderKey.Billing
  },
  permanentHold: {
    url: '/permanent-hold',
    view: '/view',
    unhold: '/unhold',
    headers: HeaderKey.Order
  },
  holdAssortment: {
    url: '/hold-assortment-request',
    import: '/{requestType}/{reason}',
    importTemplate: '/import/templates',
    exportHoldAssortmentRequest: '/storage/download-link',
    approve: '/approve',
    reject: '/reject',
    view: '/view/{requestNo}',
    history: '/history/{requestNo}',
    cancel: '/cancel',
    headers: HeaderKey.Order
  },
  refundRequest: {
    url: '/refund-request',
    get: '/{id}',
    voidBill: '/generate/void_bill',
    preOrder: '/generate/pre_order',
    redeemGoods: '/generate/redeem_good',
    uploadAttachments: '/{refundType}/image',
    generateWorkflow: '/generate/workflow',
    fileUrl: '/fileUrl',
    submit: '/submit',
    approve: '/approve',
    reject: '/reject',
    copy: '/{id}/copy',
    cancel: '/cancel',
    headers: HeaderKey.Billing
  },
  refund: {
    url: '/refund',
    export: '/export',
    get: '/{id}',
    confirm: '/confirm',
    headers: HeaderKey.Billing
  },
  billings: {
    url: '/billings',
    headers: HeaderKey.Billing
  },
  approvalWorkFlow: {
    url: '/approval-flow',
    get: '/{id}',
    headers: HeaderKey.Workflow
  },
  audience: {
    url: '/audience',
    submit: '/submit',
    headers: HeaderKey.Membership
  },
  pointEarnTransactionReport: {
    url: '/point-earn-transaction',
    export: '/export',
    headers: HeaderKey.Report
  },
  groupOrderReport: {
    url: '/group-order',
    headers: HeaderKey.Stock
  },
  inventoryCountTransaction: {
    url: '/inventory-count-transaction',
    inventoryCountTransactionReport: '/export',
    inventoryCountTransactionReportWithPrice: '/with-price/export',
    headers: HeaderKey.Report
  },
  exportReport: {
    specialPointCompensate: '/special-point/compensate/export',
    specialPoint: '/special-point/export',
    holdAssortment: '/hold-assortment/export',
    temporaryHoldAssortment: '/temporary-hold-assortment/export',
    returnToWarehouseOrder: '/rtw-order/export',
    returnToWarehouseGR: '/rtw-gr/export',
    returnToWarehouseCharge: '/rtw-charge-report/export',
    stockTransferGrExport: '/stocks/transfer-goods-receive/export',
    stockTransferOrderExport: '/stocks/transfer-order/export',
    response: '/response-report/export',
    survey: '/task-assignment-response/survey/export',
    flashSaleOrderExport: '/flash-sale-order/export',
    onlineCoupon: '/coupon-setting/export',
    vouchersExport: '/vouchers/export',
    cjxVouchersExport: '/voucher-transaction/export',
    rewardRedeemTransaction: '/redeem-transactions/export',
    rewardOfferTransaction: '/reward-transactions/export',
    onlineCouponTransaction: '/online-coupon-transaction/export',
    onlineCouponCompensate: '/online-coupon-compensate/export',
    taskAssignmentExport: '/task-assignment/export',
    claimExport: '/claim-request/export',
    moneyIn: '/money-ins/export',
    toteAdjustment: '/tote-adjustment/export',
    preOrderCreditRemaining: '/preorder-credit-remaining/export',
    onlineCouponSummary: '/online-coupon-summary/export',
    awaitingAllocationExport: '/awaiting-allocation/export',
    groupGroupUnpickedItem: '/group-order-unpicked-items/export',
    exportAssortment: '/td_assortment/export',
    exportDcAssortment: '/dc_assortment/export',
    exportByStore: '/store_assortment/export',
    exportAssortmentLocation: '/product_by_location/export',
    exportStoreApprovalBypass: '/store-approval-bypass/export',
    crossDockInvoice: '/purchase/cross-dock-invoice/export',
    storeToteExport: '/tote-store/export',
    toteFineExport: '/tote-fine/export',
    toteInOutExport: '/tote-inout/export',
    toteInTrackingExport: '/tote-in-tracking/export',
    manualChangeDeliveryStatusExport: '/manual-change-delivery-status/export',
    destroyTransaction: '/destroy-transaction/export',
    cjxSalesTransaction: '/sales-transactions/export',
    cjxMemberRewardTransaction: '/member-reward-transactions/export',
    awaitingFirstLot: '/awaiting-first-lot/export',
    order: '/order/export',
    movingAverage: '/moving-average/export',
    receiveOrder: '/receive-order/export',
    shelfInventory: '/shelfInventory/export',
    shipment: '/shipment/export',
    goodsReceive: '/goods-receive/export',
    pointBurnTransaction: '/point-burn-transaction/export',
    deliveryOrder: '/delivery-order/export',
    rewardCatalog: '/reward-catalog/export',
    shelfFixAsset: '/shelf-fix-assets/export',
    users: '/users/export',
    storeConsultant: '/store-consultant/export',
    exportPr: '/purchase-requests/export',
    exportSupplier: '/suppliers/export',
    exportInventoryAdjustmentRequest: '/stores/count/adjusts/export',
    stockByProductExport: '/stock-by-product/export',
    stockByLocationExport: '/stock-by-location/export',
    stockCardExport: '/stocks-card/export',
    reward: '/rewards/export',
    destroyTransactionExport: '/destroys/export',
    salesSummaryReport: '/sales-summary/export',
    reduceToClearSummary: '/reduce-to-clear-summary/export',
    reduceToClearTransaction: '/reduce-to-clear-transactions/export',
    cashSettlementTransactionBeforeGoLive: '/cash-settlement-transaction-before-go-live/export',
    cashSettlementTransaction: '/cash-settlement-transaction/export',
    cashCounting: '/cash-counting/export',
    exportCompanyAssortment: '/assortment/export',
    stores: '/stores/export',
    storeConfidential: '/stores/confidential/export',
    storeOrderSchedule: '/store-order-schedule/export',
    receiptCoupon: '/receipt-coupon/export',
    stockCountByQISummary: '/stock-count/qi-summary/export',
    refundSummary: '/refund-summary/export',
    refundTransaction: '/refund-transactions/export',
    stockCountByQITransaction: '/stock-count/qi-transaction/export',
    storeAvailableAdjustmentRequest: '/store-available-adjustment-request/export',
    stockCountAssignmentSummary: '/stock-count/assignment-summary/export',
    stockCountAssignmentTransaction: '/stock-count/assignment-transaction/export',
    stockCountByStaffTransaction: '/stock-count/staff-transaction/export',
    storeExpense: '/store-expense/export',
    storeOtherIncome: '/store-other-income/export',
    salePerformance: '/sales-performance/export',
    countItemInTote: '/count-item-in-tote/export',
    shiftRecord: '/shift-record/export',
    moneyInOut: '/money-in-out/export',
    cjxSalesSummary: '/sales-summary/export',
    cafeBillOfMaterialsCost: '/cafe-bill-of-materials-cost/export',
    cafeSalesAndProfit: '/cafe-sales-and-profit/export',
    salesTax: '/sales-tax/export',
    cjxShelfInventory: '/shelf-inventory/export',
    giftWithPurchase: '/gift/export',
    giftWithPurchaseTransaction: '/gift-with-purchase-transactions/export',
    storeStockRecall: '/store-stock-recall/export',
    recallStockPackingConfirmation: '/recall-stock-packing-confirmation/export',
    stockRefillSummary: '/stock-refill/summary/export',
    stockRefillPerformance: '/stock-refill/performance/export',
    cafeOrderProcessingPerformance: '/cafe-order-processing-performance/export',
    qrPaymentTransaction: '/qr-payment-transaction-report/export',
    recallStockCheckConfirmation: '/recall-stock-check-confirmation/export',
    recallCreditNote: '/recall-credit-note/export',
    loadingGroupByWarehouse: '/loading-group-by-warehouse/export',
    storeShelfReplenishmentSummary: '/store-shelf-replenishment-summary-report/export',
    shelfReplenishmentDetail: '/shelf-replenishment-detail-report/export',
    shelfReplenishmentStaffActivity: '/shelf-replenishment-staff-activity-report/export',
    shelfReplenishmentTransaction: '/shelf-replenishment-transaction/export',
    shelfReplenishmentSummary: '/store-shelf-replenishment-summary-report/export',
    shelfReplenishmentPhotoReview: '/shelf-replenishment-photo-review/export',
    dispatchTote: '/dispatched-tote/export',
    receiveTote: '/received-tote/export',
    returnTote: '/returned-tote/export',
    collectExpiredPromotionTag: '/collect-expired-promotion-tag/export',
    checkProductTag: '/check-product-tag/export',
    storeGroup: '/store-group/export',
    supplierPartnerCoupon: '/supplier-partner-coupon/export',
    billPaymentTransaction: '/bill-payment-transaction/export',
    linemanProduct: '/online-delivery-lineman-product/export',
    linemanSalesReconcileTransaction: '/lineman-sales-reconcile-transaction/export',
    linemanOrderMissingReceipt: '/lineman-order-missing-receipt/export',
    agentPaymentTransactionReport: '/agent-payment-transaction/export',
    mobilePhoneSaleAndRefund: '/mobile-phone-sales-and-refund/export',
    refundExceptionTransaction: '/refund-exception-transaction/export',
    returnToSupplier: '/return-to-supplier/export',
    customerSatisfactionSurvey: '/customer-satisfaction-survey/export',
    productExport: '/product/export',
    productConfidentialExport: '/product_confidential/export',
    productRetailPriceConfidentialExport: '/product-retail-price-confidential/export',
    productEcommerce: '/product-ecommerce/export',
    headers: HeaderKey.Report
  },
  tote: {
    url: '/tote',
    toteInformationSummary: '/tote-information-summaries',
    toteMovement: '/tote-movements',
    toteByStore: '/tote-by-store',
    headers: HeaderKey.Tote
  },
  toteAdjustment: {
    url: '/tote/tote-adjustments',
    get: '/{toteAdjustmentNo}',
    export: '/export/{toteAdjustmentNo}',
    exportReturnFromStore: '/export/{toteAdjustmentNo}/return-from-store',
    exportTemplate: '/import/templates',
    importValidate: '/import/validates',
    importSubmit: '/import/submits',
    headers: HeaderKey.Tote
  },
  preOrderCreditTerm: {
    url: '/preorder-credit-term',
    downloadFileTemplate: '/template',
    submitImport: '/upload',
    defaultPreOrderCreditTerm: '/default-credit',
    submit: '/submit',
    list: '/settings',
    view: '/settings/{requestNo}',
    cancel: '/settings/{requestNo}/cancel',
    export: '/settings/{requestNo}/export',
    headers: HeaderKey.Billing
  },
  returnToWarehouseRequest: {
    url: '/rtw',
    get: '/{requestNo}',
    history: '/history/{requestNo}',
    template: '/import/templates',
    validate: '/import/validate',
    submit: '/import/submit',
    approve: '/approve',
    reject: '/reject',
    cancel: '/cancel',
    regenerateApprovalWorkflow: '/approval-flow/regenerate',
    headers: HeaderKey.Stock
  },
  returnToSupplier: {
    url: '/return-to-suppliers',
    get: '/{id}',
    print: '/{id}/print',
    image: '/image-signed-url',
    headers: HeaderKey.Stock
  },
  returnToWarehouseOrder: {
    url: '/rtw-order',
    get: '/{docNo}',
    history: '/history/{docNo}',
    closed: '/closed',
    headers: HeaderKey.Stock
  },
  returnToWarehouseGR: {
    url: '/rtw-gr',
    get: '/{docNo}',
    history: '/history/{docNo}',
    headers: HeaderKey.Stock
  },
  flashSaleDashboard: {
    url: '/dashboard/flash-sales',
    headers: HeaderKey.Dashboard
  },
  onlineCouponRequest: {
    url: '/coupon-setting-request',
    workflow: '/generate/workflow',
    image: '/image',
    bucketName: '/coupon-images-dev',
    history: '/history/{id}',
    validate: '/validate/{id}',
    view: '/{id}',
    submit: '/submit',
    reject: '/reject',
    cancel: '/cancel',
    approve: '/approve',
    delete: '/{id}',
    copy: '/{id}/copy',
    headers: HeaderKey.Marketing
  },
  onlineCouponManage: {
    url: '/coupon',
    template: '/manage/template',
    headers: HeaderKey.Marketing
  },
  onlineCoupon: {
    url: '/coupon-setting',
    view: '/{id}',
    cancel: '/cancel',
    history: '/history/{id}',
    headers: HeaderKey.Marketing
  },
  storeAssortmentRecommendation: {
    url: '/store-assortments',
    list: '/recommendation',
    export: '/recommendation/export',
    headers: HeaderKey.Order
  },
  holdOrderRequest: {
    url: '/hold-order-requests',
    downloadTemplate: '/import/templates',
    importValidate: '/import/validates',
    downloadUnholdTemplate: '/import/unhold/templates',
    importUnholdValidate: '/import/unhold/validates',
    submitRequest: '/submits',
    unHoldSubmitRequest: '/unhold/submits',
    get: '/{requestNo}',
    headers: HeaderKey.Order
  },
  holdOrderList: {
    url: '/hold-orders',
    items: '/{storeCode}/items',
    get: '/{storeCode}',
    export: '/hold-order/export',
    headers: HeaderKey.Order
  },
  holdOrderExport: {
    url: '/hold-order',
    export: '/export',
    headers: HeaderKey.Report
  },
  receipt: {
    url: '/receipt',
    receiptNo: '/receiptNo',
    headers: HeaderKey.Store
  },
  setting: {
    productWarehouseMapping: {
      url: '/setting',
      latest: '/product-warehouse-mapping/latest',
      history: '/history?name={settingName}',
      export: '/product-warehouse-mapping/export-template',
      import: '/product-warehouse-mapping/import',
      headers: HeaderKey.Pim
    },
    productCategoryInventory: {
      url: '/settings',
      latest: '/latest?name={settingName}',
      history: '/history?name={settingName}',
      export: '/product-category-inventory/export-template',
      import: '/product-category-inventory/import',
      headers: HeaderKey.NestMaster
    },
    productCategoryFixAssetStoreUse: {
      url: '/settings',
      latest: '/latest?name={settingName}',
      history: '/history?name={settingName}',
      export: '/product-category-fix-asset/export-template',
      import: '/product-category-fix-asset/import',
      headers: HeaderKey.NestMaster
    },
    onlineProductCategoryOwnDelivery: {
      url: '/settings',
      latest: '/latest?name={settingName}',
      history: '/history?name={settingName}',
      export: '/online-product-category/export',
      template: '/online-product-category/export-template',
      import: '/online-product-category/import',
      headers: HeaderKey.NestMaster
    },
    preOrderCategory: {
      url: '/settings',
      latest: '/latest?name={settingName}',
      history: '/history?name={settingName}',
      export: '/pre-order-category/export-template',
      import: '/pre-order-category/import',
      headers: HeaderKey.NestMaster
    },
    pricingZone: {
      url: '/settings',
      latest: '/pricing-zone',
      history: '/history?name={settingName}',
      submit: '/pricing-zone/submit',
      headers: HeaderKey.NestMaster
    },
    saleSchedule: {
      url: '/settings',
      latest: '/sale-schedule/latest',
      history: '/sale-schedule/history',
      export: '/sale-schedule/download/{id}',
      import: '/sale-schedule/import',
      remove: '/sale-schedule/{id}',
      headers: HeaderKey.Store
    },
    pettyCashEventBased: {
      url: '/settings/petty-cash-event',
      latest: '/latest',
      history: '/history',
      export: '/download/{id}',
      import: '/import',
      remove: '/{id}',
      headers: HeaderKey.Store
    },
    pettyCashDefault: {
      url: '/settings/petty-cash-default',
      latest: '/latest',
      history: '/history',
      export: '/download/{id}',
      import: '/import',
      remove: '/{id}',
      headers: HeaderKey.Store
    },
    singleLocationStockFrontStoreOnly: {
      url: '/settings/single-location-stock-front-store',
      latest: '/latest',
      history: '/history',
      export: '/download/{id}',
      import: '/import',
      remove: '/{id}',
      headers: HeaderKey.Store
    },
    refillStockSchedule: {
      url: '/settings/refill-stock-schedule',
      latest: '/latest',
      history: '/history',
      export: '/download/{id}',
      import: '/import',
      remove: '/{id}',
      headers: HeaderKey.Store
    },
    refillPriority: {
      url: '/settings/refill-priority',
      latest: '/latest',
      history: '/history',
      export: '/download/{id}',
      import: '/import',
      remove: '/{id}',
      headers: HeaderKey.Store
    },
    sapStoreCodeMapping: {
      url: '/settings',
      latest: '/latest?name={settingName}',
      history: '/history?name={settingName}',
      export: '/store-code-sap-mapping/export-template',
      import: '/store-code-sap-mapping/import',
      headers: HeaderKey.NestMaster
    },
    warehouseOperatorOrderFlow: {
      url: '/settings',
      list: '/warehouse?conditionName={conditionName}',
      headers: HeaderKey.NestMaster
    },
    storePickingUnit: {
      url: '/settings/store-picking-unit',
      latest: '/latest',
      history: '/history',
      export: '/download/{id}',
      import: '/import',
      remove: '/{id}',
      headers: HeaderKey.Store
    },
    stockCountSchedule: {
      url: '/settings/stock-count-schedule',
      latest: '/latest',
      history: '/history',
      export: '/download/{id}',
      import: '/import',
      remove: '/{id}',
      headers: HeaderKey.Stock
    },
    storeTypeExpense: {
      url: '/settings',
      get: '/store-expense-type',
      submit: '/store-expense-type/submit',
      history: '/history?name={settingName}',
      headers: HeaderKey.NestMaster
    },
    materialRequestType: {
      url: '/settings',
      get: '/material-request-type',
      submit: '/material-request-type/submit',
      history: '/history?name={settingName}',
      headers: HeaderKey.NestMaster
    },
    hotkeyItem: {
      url: '/settings',
      get: '/hotkey-item/latest',
      submit: '/hotkey-item/submit',
      history: '/hotkey-item/history',
      headers: HeaderKey.NestMaster
    },
    storeExpenseLimit: {
      url: '/settings/store-expense-limit',
      latest: '/latest',
      history: '/history',
      export: '/download/{id}',
      import: '/import',
      remove: '/{id}',
      headers: HeaderKey.Store
    },
    department: {
      url: '/settings',
      latest: '/latest?name={settingName}',
      history: '/history?name={settingName}',
      export: '/department/export',
      import: '/department/import',
      headers: HeaderKey.NestMaster
    },
    productBrand: {
      url: '/settings',
      latest: '/view/latest?name={settingName}',
      history: '/history?name={settingName}',
      export: '/product-brand/export-template',
      import: '/product-brand/import',
      headers: HeaderKey.NestMaster
    },
    productAttribute: {
      url: '/settings',
      latest: '/view/latest?name={settingName}',
      history: '/history?name={settingName}',
      export: '/product-attribute/export-template',
      import: '/product-attribute/import',
      headers: HeaderKey.NestMaster
    },
    alternativeProducts: {
      url: '/settings',
      latest: '/view/latest?name={settingName}',
      history: '/history?name={settingName}',
      export: '/alternative/export-template',
      import: '/alternative/import',
      headers: HeaderKey.NestMaster
    }
  },
  reduceToClearRate: {
    url: '/rtc',
    import: '/import',
    view: '/view',
    submit: '/submit',
    cancel: '/cancel',
    history: '/history/{id}',
    downloadFileTemplate: '/template',
    export: '/export/{docNo}',
    headers: HeaderKey.Store
  },
  reduceToClearRequest: {
    url: '/rtc-request',
    list: '/nest/list',
    view: '/nest/view/{requestNo}',
    fileUrl: '/imageSignedUrl',
    approve: '/approve',
    reject: '/reject',
    regenerateApprovalWorkflow: '/approval-flow/regenerate',
    headers: HeaderKey.Store
  },
  reduceToClear: {
    url: '/rtc',
    list: '/nest/list',
    view: '/nest/view/{docNo}',
    history: '/nest/history/{docNo}',
    headers: HeaderKey.Store
  },
  destroysRequest: {
    url: '/destroy-by-cashier-request',
    list: '/nest/list',
    view: '/nest/view/{requestNo}',
    approve: '/approve',
    reject: '/reject',
    fileUrl: '/imageSignedUrl',
    regenerateApprovalWorkflow: '/approval-flow/regenerate',
    headers: HeaderKey.Store
  },
  destroys: {
    url: '/destroy-by-cashier',
    list: '/nest/list',
    fileUrl: '/imageSignedUrl',
    view: '/nest/view/{requestNo}',
    history: '/nest/history/{docNo}',
    headers: HeaderKey.Store
  },
  promotionTransactionReport: {
    url: '/promotion-transaction',
    export: '/export',
    headers: HeaderKey.Report
  },
  materialRequestTransaction: {
    url: '/material-request-transaction',
    export: '/export',
    headers: HeaderKey.Report
  },
  stockCount: {
    url: '/stock-count',
    list: '/requests',
    view: '/request/view/{id}',
    templates: '/request/templates/{type}',
    validate: '/request/validate',
    submit: '/request/submit',
    cancel: '/request/cancel',
    export: '/request/{docNo}/export/{type}',
    history: '/request/history/{id}',
    headers: HeaderKey.Stock
  },
  stockCountReport: {
    url: '/stock-count',
    stockCountByQIDailySummary: '/qi-daily-summary/export',
    headers: HeaderKey.Stock
  },
  receiptCouponRequest: {
    url: '/receipt-coupon-setting-request',
    save: '/save',
    view: '/{requestNo}',
    fileUrl: '/imageSignedUrl',
    uploadUrl: '/images',
    list: '/list',
    submit: '/submit',
    approve: '/approve',
    reject: '/reject',
    cancel: '/cancel',
    delete: '/delete',
    copy: '/copy',
    generateApprovalWorkflow: '/generate/workflow',
    regenerateApprovalWorkflow: '/approval-flow/regenerate',
    headers: HeaderKey.Marketing
  },
  cashSettlement: {
    url: '/cash-settlement-summaries',
    list: '',
    storeList: '/view/stores',
    view: '/view?saleScheduleDate={saleScheduleDate}',
    importValidate: '/imports/validates',
    downloadFileTemplate: '/imports/templates',
    importSubmit: '/imports',
    headers: HeaderKey.Settlement
  },
  refundExceptionManagement: {
    url: '/refund-exception-managements',
    list: '',
    view: '/{refundNo}',
    history: '/{refundNo}/history',
    confirmSubmission: '/confirm-submission',
    confirmRefund: '/confirm-refund',
    confirmManualRefund: '/confirm-manual-refund',
    cancel: '/cancel',
    headers: HeaderKey.Store
  },
  qrPaymentVerification: {
    url: '/api/payment/verification-code',
    headers: HeaderKey.Pos
  },
  storeAvailableAdjustmentRequest: {
    url: '/stock-count-available-adjust-request',
    list: '/list',
    view: '/view/{requestNo}',
    approve: '/approve',
    reject: '/reject',
    regenerateApprovalWorkflow: '/approval-flow/regenerate',
    headers: HeaderKey.Stock
  },
  cafeCatalog: {
    url: '/cafe/catalog-request',
    list: '',
    importValidate: '/import/validate',
    downloadFileTemplate: '/import/templates',
    importSubmit: '/import',
    download: '/{docNo}/download',
    history: '/{docNo}/history',
    cancel: '/{docNo}/cancel',
    headers: HeaderKey.Store
  },
  cafeTopping: {
    url: '/cafe/topping-request',
    list: '',
    importValidate: '/import/validate',
    downloadFileTemplate: '/import/templates',
    importSubmit: '/import',
    download: '/{docNo}/download',
    history: '/{docNo}/history',
    cancel: '/{docNo}/cancel',
    headers: HeaderKey.Store
  },
  cafeAdvertisement: {
    url: '/cafe-advertisement',
    delete: '/{id}/delete',
    mediaUpload: '/media-upload',
    view: '/{id}/view',
    history: '/{id}/history',
    submit: '/submit',
    defaultStore: '/store-profile',
    downloadFileTemplate: '/store-profile/template',
    importValidate: '/store-profile/import',
    importSubmit: '/store-profile/submit',
    export: '/store-profile/export',
    headers: HeaderKey.Marketing
  },
  receiptCoupon: {
    url: '/receipt-coupon-setting',
    view: '/{docNo}',
    fileUrl: '/imageSignedUrl',
    list: '/list',
    cancel: '/cancel',
    history: '/history/{docNo}',
    headers: HeaderKey.Marketing
  },
  cafeMenuStationMapping: {
    url: '/cafe/menu-station-mapping-request',
    list: '',
    importValidate: '/import/validate',
    downloadFileTemplate: '/import/templates',
    importSubmit: '/import',
    download: '/{docNo}/download',
    history: '/{docNo}/history',
    cancel: '/{docNo}/cancel',
    headers: HeaderKey.Store
  },
  storeExpense: {
    url: '/store-expense-request',
    requestList: '',
    view: '/view/{docNo}',
    fileUrl: '/fileUrl',
    approveReject: '/{docNo}/actions',
    history: '/{docNo}/history',
    regenerateApprovalWorkflow: '/approval-flow/regenerate',
    headers: HeaderKey.Store
  },
  monthlySalesTarget: {
    url: '/monthly-sales-target',
    list: '/list',
    downloadFileTemplate: '/import/templates',
    importValidates: '/import/validates',
    importSubmits: '/import/submits',
    export: '/export',
    headers: HeaderKey.Store
  },
  giftWithPurchaseRequest: {
    url: '/gift-request',
    list: '/list',
    downloadFileTemplate: '/import/templates',
    importValidates: '/import/validate',
    submitValidate: '/submit/validate',
    view: '/view/{requestNo}',
    submit: '/submit',
    approve: '/approve',
    reject: '/reject',
    cancel: '/cancel',
    regenerateApprovalWorkflow: '/approval-flow/regenerate',
    headers: HeaderKey.Marketing
  },
  giftWithPurchase: {
    url: '/gift',
    view: '/view/{docNo}',
    list: '/list',
    cancel: '/cancel',
    changeExpiration: '/change-expire-date',
    history: '/history/{docNo}',
    headers: HeaderKey.Marketing
  },
  cafeMenuRestriction: {
    url: '/cafe/menu-restriction-request',
    list: '',
    importValidate: '/import/validate',
    downloadFileTemplate: '/import/templates',
    importSubmit: '/import',
    download: '/{docNo}/download',
    history: '/{docNo}/history',
    cancel: '/{docNo}/cancel',
    cancelActive: '/{docNo}/cancel-active',
    headers: HeaderKey.Store
  },
  stockStoreRecall: {
    url: '/recall',
    view: '/view/{docNo}',
    list: '/list',
    submit: '/submit',
    save: '/save',
    uploadImages: '/upload',
    imageSignedUrl: '/imageSignedUrl',
    recallTracking: '/tracking/{docNo}/export',
    cancel: '/cancel',
    downloadTemplate: '/articles/download',
    import: '/articles/import',
    delete: '/delete',
    headers: HeaderKey.Store
  },
  productArticle: {
    url: '/articles',
    list: '/list',
    headers: HeaderKey.Pim
  },
  supplierPartnerCoupon: {
    url: '/supplier-partner-coupon',
    list: '/list',
    view: '/detail',
    history: '/history',
    download: '/product-export',
    downloadStore: '/store-export',
    headers: HeaderKey.Marketing
  },
  workInstruction: {
    url: '/work-instruction',
    list: '',
    view: '/detail',
    history: '/history',
    download: '/export',
    uploadFile: '',
    cancelUploadFile: '/cancel',
    fileUrl: '/fileUrl',
    delete: '/{docNo}/delete',
    headers: HeaderKey.Store
  },
  workInstructionStoreGroup: {
    url: '/work-instruction/store-group',
    list: '',
    importValidate: '/import/validate',
    downloadFileTemplate: '/import/templates',
    importSubmit: '/import',
    delete: '/{docNo}/delete',
    download: '/{docNo}/download',
    headers: HeaderKey.Store
  },
  workSchedule: {
    url: '/work-instruction/schedule',
    list: '',
    importValidate: '/import/validate',
    downloadFileTemplate: '/import/templates',
    importSubmit: '/import',
    delete: '/{docNo}/delete',
    download: '/{docNo}/download',
    downloadSummary: '/{docNo}/download-summary',
    cancel: '/{docNo}/cancel',
    history: '/{docNo}/history',
    headers: HeaderKey.Store
  },
  alcoholRestrictDate: {
    url: '/alcohol-sale-restrict',
    list: '/list',
    downloadTemplate: '/stores/template/export',
    validateStore: '/store/validate',
    submit: '/submit',
    exportStore: '/store-export/{requestId}',
    history: '/{requestId}/history',
    listYear: '/list-year',
    cancel: '/cancel',
    headers: HeaderKey.Store
  },
  purchaseWithPurchaseImage: {
    url: '/supplier-partner-coupon-pwp',
    list: '/list',
    upload: '/upload/{docNo}',
    history: '/history',
    export: '/export-redeem/{docNo}',
    signedUrl: '/signed-url',
    validate: '/validate',
    headers: HeaderKey.Marketing
  },
  promotionTag: {
    url: '/promotion-tag',
    reset: '/reset',
    headers: HeaderKey.Store
  },
  hqApprovalCodePortal: {
    url: '/approval-by-code',
    headers: HeaderKey.Workflow
  },
  ownDeliveryBannerRequest: {
    url: '/own-delivery-banner-requests',
    uploadImage: '/images/{uuid}',
    imageSignedUrl: '/image-signed-url',
    list: '',
    view: '/view/{bannerNo}',
    submit: '/submit',
    generateApprovalWorkflow: '/generate-workflow',
    viewRequest: '/{requestNo}',
    approve: '/approve',
    reject: '/reject',
    history: '/{requestNo}/history',
    cancel: '/cancel',
    headers: HeaderKey.NestMaster
  },
  ownDeliveryBanner: {
    url: '/own-delivery-banners',
    list: '',
    cancel: '/cancel',
    headers: HeaderKey.NestMaster
  },
  pim: {
    url: '/pim',
    images: '/images',
    imageAssetUpload: '/images/asset/upload',
    videoAssetUpload: '/video/asset/upload',
    saveDraft: '/requests',
    requestsDetail: '/requests/{requestId}',
    requestExists: '/requests/exists/{articleNo}',
    existsBarcode: '/requests/exists/barcode/{barcode}',
    freshLiteCategories: '/fresh-lite-categories',
    usedByCodeeFreshLite: '/fresh-lite-categories/{code}',
    requestList: '/requests/list',
    requestHistory: '/requests/{requestId}/history',
    productList: '/products/list',
    productDetail: '/products/{articleNo}',
    productMovingAvg: '/products/{articleNo}/moving-avg',
    alternativeProducts: '/products/{articleNo}/alternative-products',
    supplierPriceConfigTemplate: '/supplier-price-configs/{deliveryMethod}/template',
    importSupplierPrice: '/supplier-price-configs/{deliveryMethod}/import',
    supplierPriceByImportId: '/supplier-price-configs/import',
    exportSupplierPrice: '/supplier-price-configs/{requestNo}/export',
    exportSupplierPriceByArticle: '/supplier-price-configs/{articleNo}/{deliverySource}/export',
    exportSupplierPriceChange: '/supplier-price-configs/change/export/{id}',
    generateWorkflow: '/requests/generate-workflow',
    submit: '/requests/submit',
    viewSupplierPrice: '/products/supplier-price',
    approve: '/requests/{requestId}/approve',
    reject: '/requests/{requestId}/reject',
    cancel: '/requests/{requestId}/cancel',
    pendingChanges: '/requests/{requestId}/pending-changes',
    processingDocuments: '/requests/validate/processing-documents',
    validateProductEdit: '/requests/validate/product-edit',
    history: '/products/{articleNo}/history',
    regenerateApprovalWorkflow: '/requests/{requestId}/approval-flow/regenerate',
    bulkImportTemplate: '/bulk-import-requests/{importType}/template',
    bulkImportNewProductImport: '/bulk-import-requests/new-product/import',
    bulkImportProductMasterDataImport: '/bulk-import-requests/update-product/import',
    bulkImportSupplierPriceTemplate: '/bulk-import-requests/supplier-price/template',
    bulkImportSupplierPriceImport: '/bulk-import-requests/supplier-price/import',
    bulkImportGenerateWorkflow: '/bulk-import-requests/{importType}/generate-workflow',
    bulkImportSupplierPriceSubmit: '/bulk-import-requests/supplier-price/submit',
    bulkImportRetailPriceTemplate: '/bulk-import-requests/retail-price/template',
    bulkImportRetailPriceImport: '/bulk-import-requests/retail-price/import',
    bulkImportRetailPriceGenerateWorkflow: '/bulk-import-requests/retail-price/generate-workflow',
    bulkImportRetailPriceSubmit: '/bulk-import-requests/retail-price/submit',
    bulkImportSupplierPriceApprove: '/bulk-import-requests/{requestId}/approve',
    bulkImportSupplierPriceReject: '/bulk-import-requests/{requestId}/reject',
    bulkImportSupplierPriceCancel: '/bulk-import-requests/{requestId}/cancel',
    bulkImportAssetsUploadUrls: '/bulk-import-requests/{importType}/{importId}/upload-urls',
    bulkImportAssetsCommit: '/bulk-import-requests/{importType}/{importId}/commit',
    bulkImportAssetsCancel: '/bulk-import-requests/{importType}/{importId}',
    bulkImportSubmit: '/bulk-import-requests/{importType}/submit',
    bulkImportRequestList: '/bulk-import-requests/list',
    bulkImportRequestDetail: '/bulk-import-requests/{requestId}',
    bulkImportRequestHistory: '/bulk-import-requests/{requestId}/history',
    bulkImportRequestDownloadFile: '/bulk-import-requests/{requestId}/download-file',
    bulkImportRequestRegenerateWorkflow: '/bulk-import-requests/{requestId}/approval-flow/regenerate',
    headers: HeaderKey.Pim
  },
  exchangeRate: {
    url: '/exchange-rates',
    headers: HeaderKey.NestMaster
  }
};
